import * as React from 'react';
import { useState } from 'react';
import { alpha } from '@mui/material/styles';
import {
  Box,
  Stack,
  Typography,
  TextField,
  Button,
  Paper,
  Container
} from '@mui/material';

export default function GetHelp(props) {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: '',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log('Help request submitted:', formData);
    // You could POST to a backend or trigger SNS/email here
    setFormData({ name: '', email: '', message: '' });
  };

  return (
    <Box sx={{ width: '100%', maxWidth: { sm: '100%', md: '1700px' }, mx: 'auto' }}>
      <Typography variant="body1" sx={{ color: 'text.secondary', fontWeight: 600, mt: 2 }}>
        Get Help
      </Typography>
      <Box
        component="main"
        sx={(theme) => ({
          flexGrow: 1,
          backgroundColor: theme.vars
            ? `rgba(${theme.vars.palette.background.defaultChannel} / 1)`
            : alpha(theme.palette.background.default, 1),
          overflow: 'auto',
          p: 3,
        })}
      >
        <Container maxWidth="sm">
          <Box display="flex" justifyContent="center">
            <Paper
              elevation={3}
              sx={{
                p: 4,
                borderRadius: 2,
                width: '100%',
              }}
            >
              <Typography component="h2" variant="h5" gutterBottom align="center">
                Need Help? Reach Out Below
              </Typography>
              <Typography variant="body2" paragraph align="center">
                Fill out the form and a Rocket Offer team member will get back to you shortly.
              </Typography>

              <form onSubmit={handleSubmit}>
                <Stack spacing={2}>
                  <TextField
                    label="Name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    fullWidth
                    required
                  />
                  <TextField
                    label="Email"
                    name="email"
                    type="email"
                    value={formData.email}
                    onChange={handleChange}
                    fullWidth
                    required
                  />
                  <TextField
                    label="Message"
                    name="message"
                    multiline
                    rows={4}
                    value={formData.message}
                    onChange={handleChange}
                    fullWidth
                    required
                  />
                  <Button type="submit" variant="outlined">
                    Submit
                  </Button>
                </Stack>
              </form>
            </Paper>
          </Box>
        </Container>
      </Box>
    </Box>
  );
}
